var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-4 bg-white rounded-lg h-100"},[_c('ReportCharts',{attrs:{"mandatory-filter":[
      {
        name: 'date_range',
        title: 'Date range',
        valueFieldName: '',
      },
    ],"urls":_vm.urls}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }